import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 4q.6 0 1 .6l3.1 6.3 7 1a1 1 0 0 1 .6 1.9l-5 5 1.1 7q0 .6-.4 1a1 1 0 0 1-1.1 0L16 23.8l-6.3 3.2a1 1 0 0 1-1.5-1.1l1.1-7-5-5A1 1 0 0 1 5 12l7-1.1L15 4.6A1 1 0 0 1 16 4m0 3.4-2.5 5a1 1 0 0 1-.8.5l-5.5.8 4 4q.3.4.2.9l-.8 5.5 5-2.5a1 1 0 0 1 .9 0l5 2.5-1-5.5q0-.5.3-1l4-3.9-5.5-.8a1 1 0 0 1-.8-.6z" })
});
export default SvgStarRegularIcon;
